import { ecommerceEvent, slugify } from '@grupoboticario/tag-book-sellout'
import { ProductTagService } from '../productTagService'
import { ProductItem, GoogleAnalyticsService } from '@grupoboticario/barril-del-chavo'
import { ShopWindowType } from 'src/components/molecules/ShopWindow/types'

function enhanceWithLowStockDimensions(item: ProductItem) {
  try {
    const hasLowStockTag = ProductTagService.hasTagLowStock(item.tags ?? [])

    return {
      ...item,
      category5: hasLowStockTag ? 'poucas-unidades' : undefined,
      status: hasLowStockTag ? 'poucas-unidades' : item.status,
    }
  } catch {
    return item
  }
}

export type ViewListItemEventArgs = {
  listName: string
  products: ProductItem[]
}

export function sendViewItemListEvent({ listName, products }: ViewListItemEventArgs) {
  ecommerceEvent({
    eventName: 'view_item_list',
    products: products.map(enhanceWithLowStockDimensions),
    parameters: {
      item_list_name: listName,
      item_list_id: slugify(listName),
    },
  })
}

export interface trackShopWindowGAEventsArgs {
  cd_interaction_detail: string
  cd_section: ShopWindowType
}

export const trackShopWindowGAEvents = ({
  cd_interaction_detail,
  cd_section,
}: trackShopWindowGAEventsArgs) => {
  const eventData = {
    event: 'analytics-event',
    event_parameters: {
      event_name: 'interaction_vitrines',
      cd_interaction_detail: cd_interaction_detail,
      cd_section: slugify(cd_section),
    },
  }

  GoogleAnalyticsService.event(eventData)
}
